import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import ContactPage from "./pages/ContactPage";
import CarsPage from "./pages/CarsPage";
import BookingPage from "./pages/BookingPage";
import TransitionToTop from "./common/transitionToTop";
import FeaturesPage from "./pages/FeaturesPage";
import { Toaster } from "react-hot-toast";

function App() {
  return (
    <>
      <Router>
        <TransitionToTop />
        <Toaster />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/features" element={<FeaturesPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/cars" element={<CarsPage />} />
          <Route path="/bookings" element={<BookingPage />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
